import React from 'react'
import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import type { SearchNumber } from '@edge/spark/io-dashboards'
import { formatStatsValue, type StatsValue } from '../../../utils'

const Flex = styled('div')`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`

interface Props {
    stats?: StatsValue
    searchNumber?: SearchNumber
}

export const PrimaryStatsValue: React.VFC<Props> = ({ searchNumber, stats }: Props) => {
    if (!stats || !searchNumber) {
        return <Flex />
    }

    const { dataField } = searchNumber

    if (!dataField || dataField === 'none') {
        return <Flex />
    }

    return (
        <Flex>
            <Typography
                sx={{
                    color: 'black',
                    fontSize: 24,
                    py: 0.5,
                    fontWeight: 500,
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                }}
            >
                {formatStatsValue(stats, dataField)}
            </Typography>
        </Flex>
    )
}

export default PrimaryStatsValue
export type { Props as PrimaryStatsValueProps }
